import React from 'react';
import { cn } from 'src/utils/className';

interface CardWithBorderProps {
  children: React.ReactNode;
  className?: string;
}

export function CardWithBorder({
  children,
  className = '',
}: CardWithBorderProps) {
  return (
    <div
      className={cn(
        'mb-6 p-4 border border-neutral-200 rounded-md bg-neutral-0',
        className,
      )}
    >
      {children}
    </div>
  );
}
